<app-card *ngIf="dealer" [title]="'admin.dealer.show.dealer information'|translate" [cardOptionBtnIcon]="'fa fa-repeat'" [cardOptionBtn]="false" [advanceButton]="dealer.exactId" [advancedButtons]="advancedButtons" (outputButtonAdvance)="calFunction($event)">
  <nav ngbNav #nav="ngbNav" class="nav nav-tabs">
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.dealer_info.general'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="row pt-2">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.companyName'|translate}}</p>
            <label class="m-b-15">{{dealer.companyName}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.address'|translate}}</p>
            <label class="m-b-15">{{dealer.address}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.zipCode'|translate}}</p>
            <label class="m-b-15">{{dealer.zipCode}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.city'|translate}}</p>
            <label class="m-b-15">{{dealer.city}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.country'|translate}}</p>
            <label class="m-b-15" *ngIf="dealer.country">{{dealer.country.name}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.phone'|translate}}</p>
            <label class="m-b-15">{{dealer.companyPhone}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.email'|translate}}
              ({{'admin.dealer_info.general'|translate}})</p>
            <label class="m-b-15">{{dealer.companyEmail}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.website'|translate}}</p>
            <label class="m-b-15">{{dealer.website}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.cocNumber'|translate}}</p>
            <label class="m-b-15">{{dealer.cocNumber}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.vatNumber'|translate}}</p>
            <label class="m-b-15">{{dealer.vatNumber}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.store_type'|translate}}</p>
            <label class="m-b-15">{{dealer.dealerType?.name|translate}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.buitendienst'|translate}}</p>
            <label class="m-b-15">{{dealer.buitendienst}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.status'|translate}}</p>
            <span *ngIf="!editStatus">
              <label class="m-b-15" [ngSwitch]="dealer.status">
                <span *ngSwitchCase="getDealer().INVOICEDEALER_ACTIVE">{{'global.active'|translate}}</span>
                <span *ngSwitchCase="getDealer().INVOICEDEALER_ON_HOLD">{{'global.on_hold'|translate}}</span>
                <span *ngSwitchCase="getDealer().INVOICEDEALER_INACTIVE">{{'global.inactive'|translate}}</span>
              </label>
              <a (click)="activateEditStatus()" class="action-button ripple light">
                <i class="fa fa-pencil p-2"></i>
              </a>
            </span>
            <ng-select [items]="statuses" *ngIf="editStatus" (change)="saveStatus($event)" class="w-50" [(ngModel)]="dealer.status" bindLabel="label" bindValue="value" [clearable]="false"></ng-select>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.dealer_number'|translate}}</p>
            <label class="m-b-15">{{dealer.debtor}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.profile'|translate}}</p>
            <span *ngIf="!editProfile">
              <label class="m-b-15">{{getDealerProfiles(dealer.profiles)}}</label>
              <a (click)="activateEditProfile()" class="action-button ripple light">
                <i class="fa fa-pencil p-2"></i>
              </a>
            </span>
            <ng-select [items]="profileOptions" *ngIf="editProfile" (change)="saveProfile($event)" [(ngModel)]="currentDealerProfiles" bindLabel="label" bindValue="value" [clearable]="false" [multiple]="true"></ng-select>
          </div>
        </div>
      </ng-template>
    </div>
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.dealer_info.financial'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="row pt-2">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.companyName'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.companyName}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.address'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.address}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.zipCode'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.zipCode}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.city'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.city}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.country'|translate}}</p>
            <label class="m-b-15" *ngIf="dealer.invoiceDealer?.country">{{dealer.invoiceDealer.country.name}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.phone'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.phone}}</label>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.email'|translate}}
              ({{'doctrine.invoice_dealer.invoice_email'|translate}})</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.email}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.cocNumber'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.cocNumber}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.vatNumber'|translate}}</p>
            <label class="m-b-15">{{dealer.invoiceDealer?.vatNumber}}</label>
          </div>
          <div class="col-sm-12 col-xl-2">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.paymentCondition'|translate}}</p>
            <label class="m-b-15">{{getPaymentCondition(dealer.invoiceDealer?.paymentCondition)}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.bundleInvoices'|translate}}</p>
            <label *ngIf="!editBundleInvoice" class="m-b-15">
              {{(dealer.invoiceDealer?.bundleInvoices ? 'global.yes' : 'global.no') | translate}}
              <a (click)="activateEditBundleInvoices()" class="action-button ripple light">
                <i class="fa fa-pencil p-2"></i>
              </a>
            </label>
            <ng-select [items]="yesNoOptions" *ngIf="editBundleInvoice" (change)="saveBundleStatus($event)" class="w-50"
                       [(ngModel)]="dealer.invoiceDealer.bundleInvoices"
                       bindLabel="label" bindValue="value" [clearable]="false">
            </ng-select>
          </div>
          <div class="col-sm-12 col-xl-3">
            <p class="text-muted m-b-10">{{'doctrine.invoice_dealer.salesVatCode'|translate}}</p>
            <label class="m-b-15">
              {{dealer.invoiceDealer?.salesVatPercentage}}%
            </label>
          </div>
        </div>
      </ng-template>
    </div>
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'doctrine.order.statuses.delivery'|translate}}</a>
      <ng-template ngbNavContent>
        <div *ngIf="dealer.secondaryDeliveryContact" class="d-flex justify-content-end mt-2 w-100" >
          <p class="text-muted mt-1">{{'doctrine.delivery_contact.default'|translate}}</p>
          <label *ngIf="!editDefaultDelivery" class="ms-3 w-auto">
            {{(dealer.defaultDelivery == 'secondary' ? 'doctrine.delivery_contact.secondary' : 'doctrine.delivery_contact.primary') | translate}}
            <a (click)="activateEditDefaultDelivery()" class="action-button ripple light">
              <i class="fa fa-pencil p-2"></i>
            </a>
          </label>
          <ng-select [items]="defaultDeliveryOptions" *ngIf="editDefaultDelivery" (change)="saveDefaultDelivery($event)" class="ms-3 w-auto"
                     [(ngModel)]="dealer.defaultDelivery"
                     bindLabel="label" bindValue="value" [clearable]="false">
          </ng-select>
        </div>
        <ng-container *ngIf="dealer.deliveryContact">
          <strong class="m-t-10 m-b-10 d-block">{{'admin.primary_delivery_contact'|translate}}</strong>
          <div class="row pt-2">
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.company_name'|translate}}</p>
              <label class="m-b-15">{{dealer.deliveryContact?.companyName}}</label>
            </div>
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.address'|translate}}</p>
              <label class="m-b-15">{{dealer.deliveryContact?.address}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.postal_code'|translate}}</p>
              <label class="m-b-15">{{dealer.deliveryContact?.postalCode}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.city'|translate}}</p>
              <label class="m-b-15">{{dealer.deliveryContact?.city}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.country'|translate}}</p>
              <label class="m-b-15">{{dealer.deliveryContact?.country.name}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.contact_person'|translate}}</p>
              <label class="m-b-15">{{dealer.deliveryContact?.contactPerson}}</label>
            </div>
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.email'|translate}}</p>
              <label class="m-b-15">{{dealer.deliveryContact?.email}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.user.phone'|translate}}</p>
              <label class="m-b-15">{{dealer.deliveryContact?.phone}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.advance_call'|translate}}</p>
              <label *ngIf="dealer.deliveryContact && !editAdvancedCall" class="m-b-15">
                {{(dealer.deliveryContact.isAdvancedCall ? 'doctrine.delivery_contact.yes' : 'doctrine.delivery_contact.no') | translate}}
                <a (click)="activateEditAdvanceCall()" class="action-button ripple light">
                  <i class="fa fa-pencil p-2"></i>
                </a>
              </label>
              <ng-select [items]="yesNoOptions" *ngIf="editAdvancedCall" (change)="saveAdvanceCall($event)" class="w-50"
                         [(ngModel)]="dealer.deliveryContact.isAdvancedCall"
                         bindLabel="label" bindValue="value" [clearable]="false">
              </ng-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.times'|translate}}</p>
              <label class="m-b-15" style="white-space:pre-wrap;">{{dealer.deliveryContact?.deliveryTimes}}</label>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="dealer.secondaryDeliveryContact">
          <!--  secondary delivery  -->
          <strong class="m-t-10 m-b-10 d-block">{{'admin.secondary_delivery_contact'|translate}}</strong>
          <div class="row pt-2">
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.company_name'|translate}}</p>
              <label class="m-b-15">{{dealer.secondaryDeliveryContact?.companyName}}</label>
            </div>
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.address'|translate}}</p>
              <label class="m-b-15">{{dealer.secondaryDeliveryContact?.address}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.postal_code'|translate}}</p>
              <label class="m-b-15">{{dealer.secondaryDeliveryContact?.postalCode}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.city'|translate}}</p>
              <label class="m-b-15">{{dealer.secondaryDeliveryContact?.city}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.country'|translate}}</p>
              <label class="m-b-15">{{dealer.secondaryDeliveryContact?.country.name}}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.contact_person'|translate}}</p>
              <label class="m-b-15">{{dealer.secondaryDeliveryContact?.contactPerson}}</label>
            </div>
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.email'|translate}}</p>
              <label class="m-b-15">{{dealer.secondaryDeliveryContact?.email}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.user.phone'|translate}}</p>
              <label class="m-b-15">{{dealer.secondaryDeliveryContact?.phone}}</label>
            </div>
            <div class="col-sm-12 col-xl-2">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.advance_call'|translate}}</p>
              <label *ngIf="dealer.secondaryDeliveryContact && !editSecondaryAdvancedCall" class="m-b-15">
                {{(dealer.secondaryDeliveryContact.isAdvancedCall ? 'doctrine.delivery_contact.yes' : 'doctrine.delivery_contact.no') | translate}}
                <a (click)="activateEditAdvanceCall(true)" class="action-button ripple light">
                  <i class="fa fa-pencil p-2"></i>
                </a>
              </label>
              <ng-select [items]="yesNoOptions" *ngIf="editSecondaryAdvancedCall" (change)="saveAdvanceCall($event)" class="w-50"
                         [(ngModel)]="dealer.secondaryDeliveryContact.isAdvancedCall"
                         bindLabel="label" bindValue="value" [clearable]="false">
              </ng-select>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-xl-3">
              <p class="text-muted m-b-10">{{'doctrine.delivery_contact.times'|translate}}</p>
              <label class="m-b-15" style="white-space:pre-wrap;">{{dealer.deliveryContact?.deliveryTimes}}</label>
            </div>
          </div>
        </ng-container>
      </ng-template>
    </div>
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'doctrine.delivery_contact.contact_person'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="row pt-2">
          <div class="col-md-12">
            <app-dealer-grid [grid]="contactGrid"></app-dealer-grid>
          </div>
        </div>
      </ng-template>
    </div>
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.dealer_info.user_system'|translate}}</a>
      <ng-template ngbNavContent>
        <div class="row pt-2">
          <div class="col-md-12">
            <app-dealer-grid [grid]="archive ? userArchiveGrid : userGrid"></app-dealer-grid>
            <button *ngIf="!archive" class="btn btn-primary ripple light pull-left my-3" type="button"
                    (click)="openManageUserModal(null)">
              <i class="feather icon-plus ng-star-inserted"></i><label
              class="mb-0 ms-2"> {{ 'global.add' | translate}}</label>
            </button>
            <button class="btn btn-primary ripple light pull-right my-3" type="button" (click)="switchShowArchive()">
              {{ (archive ? 'admin.dealer.show.employee_users' : 'global.view_archive')|translate}}
            </button>
            <app-manage-user
              *ngIf="showManageDealerUser"
              [currentDelivery]="deliveryUserId"
              [refresh]="refreshModal"
              [showModal]="showManageDealerUser"
              [userInput]="editingUser"
              [manageProfile]="manageProfile"
              [userEditCondition]="false"
              [isFirstUser]="noSystemUser"
              (notifyParent)="refreshGrid($event)">
            </app-manage-user>
            <app-modal-basic #deleteModal>
              <div class="app-modal-header">
                <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'user'} }}</h4>
                <button type="button" class="close basic-close" (click)="deleteModal.hide()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="app-modal-body">
                <p>{{ 'global.soft_delete_body' | translate}}: <b [innerHTML]="userFullname"></b></p>
                <div *ngIf="isAdminDealer()" class="app-modal-form">
                  <p>{{ nonAdminUsers.length ? ('global.select_another_admin' | translate) : ('global.admin_delete' | translate) }}</p>
                  <ng-select *ngIf="nonAdminUsers.length" [items]="nonAdminUsers" (change)="saveStatus($event)" class="w-50" [(ngModel)]="newAdminDealer" bindLabel="label" bindValue="value" [clearable]="false"></ng-select>
                </div>
              </div>
              <div class="app-modal-footer">
                <button type="button" class="btn btn-simple ripple me-4"
                        (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
                <button *ngIf="!this.isUserDelete" type="button" class="btn btn-primary ripple light"
                        (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
                <button *ngIf="this.isUserDelete" type="button" class="btn btn-primary ripple light"
                        (click)="softDeleteUser()">{{'global.actions.delete'|translate}}</button>
              </div>
            </app-modal-basic>
          </div>
        </div>
      </ng-template>
    </div>
    <div ngbNavItem>
      <a ngbNavLink class="nav-link">{{'admin.dealer_info.marketing_point'|translate}}</a>
      <ng-template ngbNavContent>
        <a class="ripple light dealer-point-toggle pt-2 pb-2" href="javascript:">
          <i class="fa fa-2x mt-1" [ngClass]="toggleDealerPointClass" (click)="changeDealerPointEnableStatus()"></i>
          <span class="ms-2 font-weight-bold">{{ (dealer.dealerPointEnabled ? 'admin.dealer_info.point_active' : 'admin.dealer_info.point_inactive') | translate }}</span>
        </a>
        <div class="text-muted mb-1" [innerText]="'admin.dealer.show.current_points'|translate"></div>
        <div [ngClass]="dealer.dealerPointEnabled ? 'enabled' : 'text-muted'" [innerText]="'admin.dealer.show.total_point'|translate:{number: dealer.dealerPoints}"></div>
        <button class="btn btn-primary ripple light pull-left mt-4" type="button" (click)="showEditPoints()" [disabled]="!dealer.dealerPointEnabled">
          {{ 'global.edit'|translate}}
        </button>
        <div class="clearfix"></div>
      </ng-template>
    </div>
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</app-card>

<div class="row">
  <div class="col-md-6">
    <app-card *ngIf="dealer" [title]="'admin.invoice_dealer.show.general_items'|translate">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>{{'admin.general_items.name'|translate}}</th>
            <th>{{'admin.general_items.status'|translate}}</th>
            <th>{{'admin.general_items.timestamp'|translate}}</th>
            <th>{{'admin.general_items.by'|translate}}</th>
            <th>{{'admin.general_items.location'|translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let term of dealer.userTerms">
            <td>{{term.term.file.filename}}</td>
            <td>{{'doctrine.user_term.statuses.' + term.status | translate}}</td>
            <td>{{getDateTimeFormatted(term.acceptedAt)}}</td>
            <td>{{term.name}}</td>
            <td>{{term.city}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </app-card>
    <app-card
      *ngIf="dealer"
      [cardOptionBtn]="true"
      [cardOptionBtnValue]="(editCollectionTransportationCost ? 'admin.invoice_dealer.show.edit_transportation_cost_btn' : 'admin.invoice_dealer.show.add_transportation_cost_btn')|translate"
      (outputButton)="showTransportationCostModal()"
      [title]="'admin.invoice_dealer.show.transportation_cost'|translate">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>{{'doctrine.invoice_dealer.transportation_cost.collection_name'|translate}}</th>
            <th>{{'doctrine.invoice_dealer.transportation_cost.cost'|translate}}</th>
            <th>{{'doctrine.invoice_dealer.transportation_cost.multiplier'|translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let collectionDis of collectionTransportationCosts">
            <td>{{collectionDis.collection.name}}</td>
            <td>{{collectionDis.cost | BackofficeCurrency:'EUR':'symbol-narrow':'4.2-2'}}</td>
            <td>{{collectionDis.multiplier.name}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
  <div class="col-md-6">
    <app-card
      *ngIf="dealer"
      [cardOptionBtn]="true"
      [cardOptionBtnValue]="(editCollectionDiscount ? 'admin.invoice_dealer.show.edit_discount_btn' : 'admin.invoice_dealer.show.add_discount_btn')|translate"
      (outputButton)="showDiscountModal()"
      [title]="'admin.invoice_dealer.show.discount'|translate">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
          <tr>
            <th>{{'doctrine.invoice_dealer.discount.collection_name'|translate}}</th>
            <th>{{'doctrine.invoice_dealer.discount.amount'|translate}}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let collectionDis of collectionDiscounts">
            <td>{{collectionDis.collection.name}}</td>
            <td>%{{collectionDis.discount | number}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </app-card>
  </div>
</div>

<app-modal-basic #transferModel>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.transfer_orders_title' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="closeTransferModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.transfer_orders_body' | translate}}</p>
    <div class="form-group row">
      <div class="form-group form-default form-static-label col-12">
        <ng-select required name="dealer" [items]="dealers" bindLabel="companyName" bindValue="id"
                   [(ngModel)]="transferOrderTo" [clearable]="false"
                   [typeahead]="dealerTypeHead"></ng-select>
      </div>
    </div>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="closeTransferModal()">{{'global.cancel'|translate}}</button>
    <button type="button" [disabled]="!transferOrderTo" class="btn btn-primary ripple light"
            (click)="transferOrders()">{{'global.confirm'|translate}}</button>
  </div>
</app-modal-basic>


<app-modal-basic #deleteModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_delete_title' | translate:{entity: 'dealer'} }}</h4>
    <button type="button" class="close basic-close" (click)="deleteModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_delete_body' | translate}}: <b [innerHTML]="deliveryCompanyName"></b> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="deleteModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="softDelete()">{{'global.actions.delete'|translate}}</button>
  </div>
</app-modal-basic>

<app-modal-basic #readdModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate:{entity: 'dealer'} }}</h4>
    <button type="button" class="close basic-close" (click)="readdModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}} : <b [innerHTML]="userFullname"></b> ?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="readdModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light"
            (click)="readDeliveryDealerUser()">{{'global.actions.readd'|translate}}</button>
  </div>
</app-modal-basic>

<app-collection-discount
  *ngIf="showDiscountComponent"
  [showModal]="showDiscountComponent"
  [isEdit]="editCollectionDiscount"
  [invoiceDealerId]="dealer.invoiceDealer?.id"
  [collectionDiscounts]="collectionDiscountItems"
  (closeModal)="toggleDiscountModal($event)">
</app-collection-discount>

<app-collection-transportation-cost
  *ngIf="showTransportationCostComponent"
  [showModal]="showTransportationCostComponent"
  [isEdit]="editCollectionTransportationCost"
  [invoiceDealerId]="dealer.invoiceDealer?.id"
  [collectionTransportationCosts]="collectionTransportationCostItems"
  [description]="transportationCostDescription"
  (closeModal)="toggleTransportationCostModal($event)">
</app-collection-transportation-cost>

<app-modal-basic #editPointModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_edit_title' | translate:{entity: 'dealer points'} }}</h4>
    <button type="button" class="close basic-close" (click)="editPointModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <app-classic-box #classicForm [classicBox]="classicBox" [data]="lastValue"
                     (changeForm)="enableButton($event)"></app-classic-box>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4"
            (click)="editPointModal.hide()">{{'global.cancel'|translate}}</button>
    <button [disabled]="!enableSave" type="button" class="btn btn-primary ripple light"
            (click)="saveDealerPoint()">{{'global.actions.save'|translate}}</button>
  </div>
</app-modal-basic>
